import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
type StylesProps = {
  hasParticipant: boolean;
};
export const useStyles = makeStyles<Theme, StylesProps>((theme) =>
  createStyles({
    root: (props) => ({
      position: 'relative',
      display: 'flex',
      justifyContent: props.hasParticipant ? 'space-between' : 'center',
      alignItems: 'center',
      maxWidth: 225,
      margin: '0 auto',

      [theme.breakpoints.up('md')]: {
        maxWidth: 240,
      },
      '&::before': {
        content: "''",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        display: props.hasParticipant ? 'block' : 'none',
        width: 24,
        height: 24,
        backgroundSize: 'cover',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 18L15 12L9 6' stroke='%231A1118' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
      },
    }),
  })
);
